import * as React from 'react';
import {Link} from 'react-router-dom';

import classnames from 'classnames';

import * as Leads from 'nutshell-core/leads';
import {Routing} from 'nutshell-core/routing';

import {FlameIcon} from '../icon/svg/flame-icon';

import styles from './linked-entity.module.css';

type Props = {
    lead: {
        name: string | React.ReactElement<any>;
        status?: string;
        htmlUrl: string;
        priority?: string | number;
        avatarUrl?: string;
    };
    showIcon?: boolean;
    showFlame?: boolean;
    allowWrap?: boolean;
    isLinkable?: boolean;
    newTab?: boolean;
    disableRouting?: boolean;
};

export class LinkedLeadEntity extends React.PureComponent<Props> {
    static defaultProps = {
        isLinkable: true,
    };

    render() {
        const {lead, showIcon, showFlame, allowWrap} = this.props;
        const isHot =
            Leads.leadPriorityIsHot(lead.priority) &&
            lead.status &&
            lead.status.toLowerCase() === 'open';

        // The lead "name" can either be a react element which had its html set from solr, or a string
        // We want to get the raw string back out, to put into title attributes.
        const nameText: string | null | undefined =
            lead.name && typeof lead.name === 'object'
                ? lead.name.props &&
                  lead.name.props &&
                  lead.name.props.dangerouslySetInnerHTML &&
                  lead.name.props.dangerouslySetInnerHTML.__html
                : lead.name;

        const hasName = nameText && nameText.length;
        const entityName = hasName ? (
            lead.name
        ) : (
            <span className={styles.nameless}>Unnamed lead</span>
        );
        const entityElement = (
            <div
                // @ts-expect-error
                title={nameText}
                className={classnames({
                    [styles.truncate]: !allowWrap,
                    [styles['lead-name--hot']]: isHot,
                })}
            >
                {entityName}
            </div>
        );

        const altText = `${lead.status || ''} lead icon`;

        const content = (
            <React.Fragment>
                {entityElement}
                {isHot && showFlame ? <FlameIcon size={null} wrapWithDiv={false} /> : null}
                {lead.avatarUrl && showIcon ? (
                    <img alt={altText} src={lead.avatarUrl} className={styles['icon-image']} />
                ) : undefined}
            </React.Fragment>
        );

        const containerStyleName = classnames(styles['container-leads'], {
            [styles.hot]: isHot,
        });

        if (!this.props.isLinkable) {
            return (
                <div className={containerStyleName}>
                    <div className={styles['lead-link']}>{content}</div>
                </div>
            );
        }

        return (
            <div className={containerStyleName}>
                {Routing.hasWorkingUrl() && !this.props.disableRouting ? (
                    <Link
                        className={styles['lead-link']}
                        to={new URL(lead.htmlUrl).pathname}
                        // @ts-expect-error
                        onClick={this.handleClick}
                        target={this.props.newTab ? '_blank' : undefined}
                        rel={this.props.newTab ? 'noreferrer noopener' : undefined}
                    >
                        {content}
                    </Link>
                ) : (
                    <a
                        // @ts-expect-error
                        onClick={this.handleClick}
                        href={lead.htmlUrl}
                        target={this.props.newTab ? '_blank' : undefined}
                        rel={this.props.newTab ? 'noreferrer noopener' : undefined}
                        className={styles['lead-link']}
                    >
                        {content}
                    </a>
                )}
            </div>
        );
    }

    handleClick = (e: Event) => {
        e.stopPropagation();
    };
}
